import type { EventCategoryStatistic, EventDrinkStatistic, EventTopConsumer } from "../../../services/drinkService";
import { sortParticipantsDesc } from "./utils";

type VisibleStatistic = EventDrinkStatistic | EventCategoryStatistic;

export const buildVisibleStatistics = <T extends VisibleStatistic>(
    entries: T[],
    filterParticipants: (participants: EventTopConsumer[]) => EventTopConsumer[]
): T[] => entries.flatMap((entry) => {
    const participants = filterParticipants(entry.participants);
    if (!participants.length) return [];
    const sortedParticipants = sortParticipantsDesc(participants);
    return [{
        ...entry,
        activityCount: sortedParticipants.reduce((sum, participant) => sum + participant.activityCount, 0),
        totalVolumeMl: Number(sortedParticipants.reduce((sum, participant) => sum + participant.totalVolumeMl, 0).toFixed(2)),
        totalAlcoholGrams: Number(sortedParticipants.reduce((sum, participant) => sum + participant.totalAlcoholGrams, 0).toFixed(2)),
        topConsumer: sortedParticipants[0] ?? null,
        participants: sortedParticipants,
    }];
}).sort((a, b) => b.totalVolumeMl - a.totalVolumeMl || b.totalAlcoholGrams - a.totalAlcoholGrams);
